module.exports = __webpack_public_path__ + "img/No_Data.eeeef2de.svg";